import { ApiClientReturnType, KeyLabelType, Nullable, TableDataType } from '~/types';
import api from '../http-common';

export const ReportingService = (prefix?: string) => {

  const getTradingActivityData = (data?: TradActiFilterType): ApiClientReturnType<TradingActivitieType[]> =>
    api.post(`/reporting/${prefix}/trading-activities/get-data`, data);

  const getSettingsData = (): ApiClientReturnType<TradingActivitieSettingsType> =>
    api.post(`/reporting/${prefix}/trading-activities/get-settings-data`)

  const getTradingOffers = (data?: TradActiFilterType): ApiClientReturnType<TradActOfferType[]> =>
    api.post(`/reporting/${prefix}/trading-activities/get-offers`, data)

  const getTradingReportActivitie = (): ApiClientReturnType<void> =>
    api.post(`/reporting/${prefix}/trading-activities/store-activity-log`)

  // Fixed Price

  const getFixedPriceSettings = (): ApiClientReturnType<FixedPriceSettingsType> =>
    api.post(`/reporting/${prefix}/prices/get-settings-data`)

  const getFixedPriceData = (data?: FixedPriceFilterType): ApiClientReturnType<FixedPriceDataType> =>
    api.post(`/reporting/${prefix}/prices/get-data`, data)

  // Article bookings

  const getArticleBookingsSettings = (): ApiClientReturnType<ArticleSettingsType> =>
    api.post('/reporting/article-bookings/get-settings-data')

  const getArticleBookings = (data?: ArticleFilterDataType): ApiClientReturnType<ArticleBookingType[]> =>
    api.post('/reporting/article-bookings/get-data', data)

  const getArticleBookingFarmers = (data?: ArticleFilterDataType): ApiClientReturnType<ArticleFarmerType> =>
    api.post('/reporting/article-bookings/get-farmers', data)

  // District delivery no

  const getDistrictDeliverySettings = (): ApiClientReturnType<DistrictSettingsType> =>
    api.post('/reporting/district-deliveries/get-settings-data')

  const getDistrictDeliveries = (data: DistrictFilterType): ApiClientReturnType<DistrictDeliveryType> =>
    api.post('/reporting/district-deliveries/get-data', data)

  const getDistrictDeliverieDetails = (id: string, data?: DistrictFilterType): ApiClientReturnType<DistrictDetailType> =>
    api.post(`/reporting/district-deliveries/${id}/farmers/index`, data)

  return {
    getTradingActivityData,
    getSettingsData,
    getTradingOffers,
    getTradingReportActivitie,
    getFixedPriceSettings,
    getFixedPriceData,
    getArticleBookingsSettings,
    getArticleBookings,
    getArticleBookingFarmers,
    getDistrictDeliveries,
    getDistrictDeliverySettings,
    getDistrictDeliverieDetails
  }
}

// CO2 Module

const co2ReportData = (data): ApiClientReturnType<Co2ReportDataType> =>
  api.post('/reporting/co2-footprint/get-data', data);

const co2ReportSettingsFarm = (): ApiClientReturnType<Co2SettingsType> =>
  api.post('/reporting/co2-footprint/get-settings-data');

const co2ReportSettingsAdmin = (): ApiClientReturnType<Co2SettingsTypeAdmin> =>
  api.post('/reporting/co2-footprint/get-settings-data');

const co2Footprint = (data) =>
  api.post('/reporting/co2-footprint/index', data);

const getFlagGasEmissionsSettingsData = (): ApiClientReturnType<any> =>
  api.post('/reporting/co2-footprint/flag-gas-emissions/get-settings-data');

const flagGasEmissionsIndex = (data?: any): ApiClientReturnType<any> =>
  api.post('/reporting/co2-footprint/flag-gas-emissions/index', data);

export const Co2ReportService = {
  co2ReportData,
  co2ReportSettingsAdmin,
  co2ReportSettingsFarm,
  co2Footprint,
  getFlagGasEmissionsSettingsData,
  flagGasEmissionsIndex
}

// Clima check module

const climaCheckReportData = (data): ApiClientReturnType<Co2ReportDataType> =>
  api.post('/reporting/climate-check-footprint/get-data', data);

const climaReportSettings = (): ApiClientReturnType<ClimateCheckSettingsType> =>
  api.post('/reporting/climate-check-footprint/get-settings-data');

const climaFootprint = (data) =>
  api.post('/reporting/climate-check-footprint/index', data);

const climaExportFootprint = (data) =>
  api.post('/reporting/climate-check-footprint/export', data);

export const ClimaReportService = {
  climaCheckReportData,
  climaReportSettings,
  climaFootprint,
  climaExportFootprint
}

export interface TradingActivitieSettingsType {
  chartBarColor: string;
  chartBarColor2: string;
  chartLineColor: string;
  tradingVolumeTypes: TradingVolumeType[];
  slug: string;
  label: string;
  id: number;
  code: string;
  icon: string;
  translation: string;
  textId: number;
  languageId: number;
  milkTypes: MilkType[];
}

export interface MilkType {
  id: number;
  abbreviation: string;
  name: string;
  label: string;
  milkTypeId: number;
  languageId: number;
}

interface TradingVolumeType {
  id: string;
  percent: string;
  code: string;
  icon: string;
  name: string;
  label: string;
  tradingVolumeTypeId: string;
  languageId: number;
}
export interface TradingActivitieType {
  month: string;
  maxAmount: number;
  offeredAmount: number | string;
  offeredNotConfirmedAmount: number | string;
  confirmedAmount: number | string;
  remainingAmount: number;
  avgPrice: null | string;
  minPrice: null | string;
  maxPrice: null | string;
  basePrice: null | string;
}
export interface TradActiFilterType {
  yearFrom: string,
  yearTo: string,
  monthFrom: string,
  monthTo: string,
  farmerGroupId?: string,
  farmerId?: string,
  milkTypeId?: string | number | boolean | (string | number | boolean)[],
  tradingVolumeTypeId: string | number | boolean | (string | number | boolean)[]
  month?: string
}
export interface TradActOfferType {
  id: string;
  uniqueId: string;
  price: string;
  userId: string;
  name: string;
  amount: number;
  confirmedAmount: number | null;
  confirmationDate: null | string;
  createdAt: string;
  date: string;
  status: string;
  avgProteinPrice?: string;
  avgFatPrice?: string;
  supplierNo: string;
  statusLabel: string;
}

interface FixedPriceSettingsType {
  dairy: Dairy;
  text: Text;
  months: string[];
  selectedMonth: string;
}
interface Dairy {
  chartBarColor: string;
  chartBarColor2: string;
  chartLineColor: string;
}
interface Text {
  slug: string;
  label: string;
  id: number;
  code: string;
  icon: string;
  translation: string;
  textId: number;
  languageId: number;
}
interface FixedPriceFilterType {
  month: string,
  farmerGroupId: string,
  farmerId: string
}
export interface FixedPriceDataType {
  baseData: BaseData;
  tradingMonths: TradingMonth[];
}
interface BaseData {
  month: string;
  maxPrice: string;
  avgFatPrice?: string;
  avgProteinPrice?: string;
  minPrice: string;
  avgPrice: string;
  farmerAvgPrice: string;
  minDate: string;
  maxDate: string;
  confirmedAmount: null;
}
interface TradingMonth {
  uniqueId: string;
  dateFrom: string;
  price: string;
  confirmedAmount: null;
  basePrice: string;
}
interface ArticleBookingType {
  id: number;
  uniqueId: string;
  name: string;
  unit: string;
  tax: string;
  articlesCount: string;
  netTotal: string;
  taxTotal: string;
  grossTotal: string;
  unitLabel: string;
  intervalLabel: string;
  typeLabel: string;
  grossPrice: null;
}
interface ArticleFilterDataType {
  rows: number,
  page: number,
  search: string,
  articleId: string,
  month: string
}
interface ArticleSettingsType {
  articles: Article[];
  months: Month[];
  selectedMonth: string;
}

interface Article {
  id: number;
  name: string;
  uniqueId: string;
  unitLabel: string;
  intervalLabel: string;
  typeLabel: string;
  grossPrice: null;
}

interface Month {
  key: string;
  label: string;
}
interface ArticleFarmerType {
  rows: Row[];
  total: number;
  filtered: number;
}
interface Row {
  id: number;
  uniqueId: string;
  name: string;
  unit: string;
  amount: number;
  netPrice: string;
  tax: string;
  companyName: string;
  supplierNo: null | string;
  bookingDate: string;
  grossPrice: number;
  unitLabel: string;
  intervalLabel: string;
  typeLabel: string;
}

interface DistrictSettingsType {
  months: KeyLabelType[]
  selectedMonth: string
}
interface DistrictFilterType {
  rows: number,
  page: number,
  search: string,
  month: string
  selectedMonth?: string
}

interface DistrictDeliveryType {
  districts: District[];
}
interface District {
  id: number;
  name: string;
  districtName: string;
  number: string;
  farmersCount: number;
  amount: string;
}

type DistrictDetailType = TableDataType<DetailType>
interface DetailType {
  supplierNo: string;
  companyName: string;
  totalAmount: number;
}

export interface Co2SettingsType {
  resultTypes: ResultsType[][];
  periods: Period[];
  co2Footprints: Co2Footprint[];
  perimeters: { key: number, value: number }[];
  customFilters: CustomFilter[];
  yourValueColor: string;
  bayernValueColor: string;
  texts: DiagramLabelTranslations[];
  co2FootprintSettings: {
    bayernValueColor: string
    comparisonResultsNumber: number
    dairyValueColor: string
    showLflDefaultValue: number
    yourValueColor: string
  }
  breeds: Breed[];
  dairyValueColor?: string;
  selectedData: SelectedCo2DataType;
  housingTypes: KeyLabelType[];
  administrativeDistricts: AdministrativeDistrictType[];
  subFarmers: SubFarmerType[]
}

type ClimateCheckFootprintSettings =
  Omit<Co2SettingsType['co2FootprintSettings'], 'bayernValueColor'> & {
    lflValueColor: string;
  };

export type ClimateCheckSettingsType =
  Omit<Co2SettingsType, 'bayernValueColor' | 'co2FootprintSettings' | 'resultTypes'> & {
    lflValueColor: string;
    climateCheckFootprintSettings: ClimateCheckFootprintSettings;
    resultTypes: ResultsType[];
  };

export type SubFarmerType = {
  id: string
  companyName: string
  supplierNo: Nullable<string>
}

export type SelectedCo2DataType = {
  administrativeDistrictId: number
  breedId: number
  customFilterId: Nullable<number>
  housingType: string
  perimeter: string
}

export type Co2SettingsTypeAdmin = Omit<Co2SettingsType, 'resultTypes'> & {
  resultTypes: ResultsType[];
};

export type ResultsType = {
  key: string
  label: string
  unit: string
}

export type AdministrativeDistrictType = {
  id: number
  stateId: number
  name: string
}

export interface Breed {
  id: number | string;
  slug: string;
  status: number;
  label: string;
}

export interface Co2Footprint {
  id: string;
  uniqueId: string;
  title: string;
  statusLabel: string;
}

export interface CustomFilter {
  id: number;
  name: string;
  amountFrom: number;
  amountTo: number;
  year?: number;
}

export interface Period {
  periodFrom: string;
  periodTo: string;
  statusLabel: string;
}

export interface ResultType {
  key: string;
  label: string;
}

export interface DiagramLabelTranslations {
  '0': The0;
  slug: string;
  label: string;
  translation: string
}

export interface The0 {
  id: number;
  code: string;
  icon: string;
  translation: string;
  label: string;
  textId: number;
  languageId: number;
}

export interface Co2ReportDataType {
  results: Co2ResultType;
  dairyResults: (Co2ResultType & { count: number }) | DairyResultsType;
  defaultResults: Co2ResultType;
}

type Co2ResultType = {
  value: Nullable<string | number>
}

export type DairyResultsType = {
  value: string;
  inventoryAddition: string;
  calfRearing: string;
  feeding: string;
  manureAndBedding: string;
  waterAndEnergy: string;
  dieselProductionAndCombustion: string;
  total: string;
  count: number;
}

